import classNames from "classnames";

import { UtilityIcon } from "./icons/UtilityIcon";

interface Action {
    label: string;
    onClick: () => void;
}

interface Props {
    action?: Action;
    alertMsg: string;
    linkText?: string;
    link?: string;
    variant?: "slds-alert_error" | "slds-alert_warning" | "slds-alert_offline";
    onClose?: () => void;
    disableClose?: boolean;
}

/**
 * A minimal implementation of https://www.lightningdesignsystem.com/components/alert.
 * The Alert component from the React Lightning Design Components library
 * has a bug that prevents us from using it out-of-box. It's simpler to
 * provide this implement instead.
 */
export function Alert(props: Props) {
    const alertClassNames = classNames([
        "slds-notify",
        "slds-notify_alert",
        props.variant ?? "",
    ]);
    return (
        <div className={alertClassNames} role="alert">
            <span className="slds-assistive-text">error</span>
            <span
                className="slds-icon_container slds-icon-utility-error slds-m-right_x-small"
                title="Description of icon when needed"
            >
                <UtilityIcon iconName="error" svgClass="slds-button__icon" />
            </span>
            <h2>
                {props.alertMsg}
                {props.link && props.linkText && (
                    <a className="slds-var-m-left_x-small" href={props.link}>
                        {props.linkText}
                    </a>
                )}
                {props.action && (
                    <a
                        className="slds-var-m-left_x-small"
                        onClick={props.action.onClick}
                    >
                        {props.action.label}
                    </a>
                )}
            </h2>
            {!props.disableClose && (
                <div className="slds-notify__close">
                    <button
                        className="slds-button slds-button_icon slds-button_icon-small slds-button_icon-inverse"
                        title="Close"
                        onClick={props.onClose}
                    >
                        <UtilityIcon
                            iconName="close"
                            svgClass="slds-button__icon"
                        />
                        <span className="slds-assistive-text">Close</span>
                    </button>
                </div>
            )}
        </div>
    );
}
